import type { CancelRescueKind } from "../../../shared/cancellation_reasons.js";

/** `rescue_kind` of the session card inside the refund window, on the cancel_rescue_* events. */
export const REFUND_WINDOW_SPECIALIST_KIND = "specialist_refund_window";

/**
 * Whether the confirm screen opens the session card (PIT-448): only inside the 7-day window, before
 * the refund choice, for someone Zenpost lets book (the flag behind `should_offer_support_before_cancel`),
 * when no other offer card is on the screen (gift or cheaper plan), no session is booked, the reason did
 * not already go through the session screen, and the schedule has a slot that keeps the refund
 * reachable (`slotsBeforeRefundDeadline`). A card on the same screen, never a screen of its own.
 */
export function showsRefundWindowSpecialist(args: {
  inRefundWindow: boolean;
  canBookSupport: boolean;
  otherOfferShown: boolean;
  hasBooking: boolean;
  rescueKind: CancelRescueKind;
  slotsBeforeDeadline: number;
}): boolean {
  return (
    args.inRefundWindow &&
    args.canBookSupport &&
    !args.otherOfferShown &&
    !args.hasBooking &&
    args.rescueKind !== "specialist" &&
    args.slotsBeforeDeadline > 0
  );
}

/**
 * Whether the confirm screen should load the schedule to decide on the card: everything above but the
 * slots, so nothing is fetched for someone who could never see it.
 */
export function mayShowRefundWindowSpecialist(
  args: Omit<Parameters<typeof showsRefundWindowSpecialist>[0], "slotsBeforeDeadline">,
): boolean {
  return showsRefundWindowSpecialist({ ...args, slotsBeforeDeadline: 1 });
}
